
const CLOUD_NAME = "mnet";
const UPLOAD_PRESET = "mnet11";

export const uploadToCloudinary = async (file) => {
    if (!file) return null;

    if (CLOUD_NAME === "INSERT_CLOUD_NAME_HERE" || UPLOAD_PRESET === "INSERT_UPLOAD_PRESET_HERE") {
        console.error("Cloudinary credentials are missing in src/utils/cloudinary.js");
        alert("Please configure Cloudinary credentials in src/utils/cloudinary.js");
        throw new Error("Cloudinary credentials not configured");
    }

    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', UPLOAD_PRESET);
    const fileName = file.name.split('.').slice(0, -1).join('.');
    formData.append('public_id', `${fileName}_${Date.now()}`);

    try {
        const response = await fetch(`https://api.cloudinary.com/v1_1/${CLOUD_NAME}/auto/upload`, {
            method: 'POST',
            body: formData
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error?.message || 'Upload failed');
        }

        const data = await response.json();
        return {
            url: data.secure_url,
            name: file.name
        };
    } catch (error) {
        console.error("Error uploading to Cloudinary:", error);
        throw error;
    }
};
